module.exports = __webpack_public_path__ + "img/visa_logo.e847d897.svg";